/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface OnlineStatusItem
 */
export interface OnlineStatusItem {
    /**
     *
     * @type {number}
     * @memberof OnlineStatusItem
     */
    onlineStatusItemId?: number;
    /**
     *
     * @type {string}
     * @memberof OnlineStatusItem
     */
    deviceIdentity?: string;
    /**
     *
     * @type {Date}
     * @memberof OnlineStatusItem
     */
    createdAt?: Date;
    /**
     *
     * @type {Date}
     * @memberof OnlineStatusItem
     */
    updatedAt?: Date;
    /**
     *
     * @type {boolean}
     * @memberof OnlineStatusItem
     */
    online?: boolean;
    /**
     *
     * @type {string}
     * @memberof OnlineStatusItem
     */
    reason?: string;
    /**
     *
     * @type {string}
     * @memberof OnlineStatusItem
     */
    centralSystem?: string;
}

/**
 * Check if a given object implements the OnlineStatusItem interface.
 */
export function instanceOfOnlineStatusItem(
    value: object,
): value is OnlineStatusItem {
    return true;
}

export function OnlineStatusItemFromJSON(json: any): OnlineStatusItem {
    return OnlineStatusItemFromJSONTyped(json, false);
}

export function OnlineStatusItemFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): OnlineStatusItem {
    if (json == null) {
        return json;
    }
    return {
        onlineStatusItemId:
            json["onlineStatusItemId"] == null
                ? undefined
                : json["onlineStatusItemId"],
        deviceIdentity:
            json["deviceIdentity"] == null ? undefined : json["deviceIdentity"],
        createdAt:
            json["createdAt"] == null ? undefined : new Date(json["createdAt"]),
        updatedAt:
            json["updatedAt"] == null ? undefined : new Date(json["updatedAt"]),
        online: json["online"] == null ? undefined : json["online"],
        reason: json["reason"] == null ? undefined : json["reason"],
        centralSystem:
            json["centralSystem"] == null ? undefined : json["centralSystem"],
    };
}

export function OnlineStatusItemToJSON(value?: OnlineStatusItem | null): any {
    if (value == null) {
        return value;
    }
    return {
        onlineStatusItemId: value["onlineStatusItemId"],
        deviceIdentity: value["deviceIdentity"],
        createdAt:
            value["createdAt"] == null
                ? undefined
                : value["createdAt"].toISOString(),
        updatedAt:
            value["updatedAt"] == null
                ? undefined
                : value["updatedAt"].toISOString(),
        online: value["online"],
        reason: value["reason"],
        centralSystem: value["centralSystem"],
    };
}
